import { atom } from 'jotai';

import { UserInfo } from '@/types/user';

export const userInfoAtom = atom<UserInfo | null>(null);
